import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { UitkExpando } from '../uitk-expando.esm.js';
var UitkExpandoListItem = function (props) {
  var _a = props.triggerPosition,
    triggerPosition = _a === void 0 ? 'leading' : _a,
    otherProps = __rest(props, ["triggerPosition"]);
  return React.createElement(UitkExpando, __assign({}, otherProps, {
    triggerPosition: triggerPosition,
    type: "list"
  }));
};
UitkExpandoListItem.displayName = 'UitkExpandoList';
export { UitkExpandoListItem };